import React from 'react';

import { TextField, useRecordContext } from 'react-admin';

import { get, isEmpty, keyBy } from 'lodash';

import { Typography } from '@mui/material';

import Answer from '../Answer';

import conflictFields from '../../../../constants/conflictFields';
import { PurposeParameters } from '../../questionParameters';

export type PurposeFormAnswer = {
  options: string[];
}

const ValueField = ({
  extraParameters,
}: {
  extraParameters?: PurposeParameters;
}) => {
  const record = useRecordContext<{ value: PurposeFormAnswer }>();

  if (!record) return null;

  const options = get(record, 'value.options');
  const sx = get(record, 'sx', {});

  if (isEmpty(options)) return <Typography>-</Typography>;

  const mapFields = keyBy(
    extraParameters?.options?.map((option) => ({
      id: option.id,
      name: extraParameters.choiceLabels?.[option.id] ?? option.label,
    })),
    'id',
  );

  const mappedValues = options?.map((v: string) => get(mapFields, v, { name: v }).name);

  const value = mappedValues.join(', ');

  return <TextField record={{ value }} sx={sx} source="value" emptyText="-" fontWeight="bold" />;
};

const Purpose = ({
  extraParameters,
}: {
  extraParameters?: PurposeParameters;
}) => (
  <Answer
    label={extraParameters?.label ?? ''}
    source="purpose"
    datapoint={conflictFields.PURPOSE}
    identificationInfo={undefined}
  >
    <ValueField extraParameters={extraParameters} />
  </Answer>
);

Purpose.ValueField = ValueField;

export default Purpose;
